module.exports = __webpack_public_path__ + "img/18.9801848a.jpeg";